import React, { useEffect, useState } from "react";
import { useAppContext } from "../../Context/context";
import Summary from "../../Components/Dashboard/Summary";
import { Roles } from "../../Utils/enum";
import { Offers } from "../../Components/Dashboard/Offers";
import { Grid } from "@mui/material";
import Attendance from "../../Components/Dashboard/Attendance";
import SiteTable from "../../Components/Dashboard/SiteTable";
import ProjectTable from "../../Components/Dashboard/ProjectTable";

const Dashboard = () => {
  const { user } = useAppContext();

  const showDashboardComponentRoleWise = () => {
    if (user?.userType === Roles.SuperAdmin) {
      return (
        <>
          <Summary />
          <ProjectTable/>
          <SiteTable/>
          {/* <ScheduledMeeting />
          <TotalRevenue />
          <Investors />
          <VisitorInsights />
          <Offers /> */}
        </>
      )
    } else if (user?.userType === Roles.Admin) {
      return (<>
        <Summary />
        {/* <VisitorInsights />
        <ScheduledMeeting /> */}
      </>
      )
    } else if (user?.userType === Roles.Employe) {
      return (
        <>
          <Attendance />
          <Summary />
        </>
      )
    }
  }

  return (
    <>
      <Grid container spacing={1} xs={12} sm={12} md={12} lg={12}>
        {showDashboardComponentRoleWise()}
      </Grid>
    </>
  );
};

export default Dashboard;
